module.exports = __webpack_public_path__ + "h5/img/icon_wode_y.8ade7549.png";